// Módulo Inventario — Punto Cero OS.
// Datos NEUTRALIZADOS: la fuente real es el backend (inventory.service vía API).
// Estructura preservada; sin productos/precios legacy.

export const PRODUCTS = [];
export const CATEGORIES = [];
export const MOVEMENTS_IN = [];
export const MOVEMENTS_OUT = [];
